import { useQuery } from "@tanstack/react-query";
import { PulseInstanceQueryOptions } from "@pulse/api/queryApi";
import { useParams } from "@tanstack/react-router";

export const useCurrentPulseInstance = () => {
    const { pulseId } = useParams({ from: "/_hub/$customerId/pulse/$pulseId" });
    return useQuery(PulseInstanceQueryOptions({ pulseInstanceId: Number(pulseId) }));
};
